import React from 'react';

const IOS_URL = 'https://apps.apple.com/us/app/strapin/id6739948260';
const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.strapin.chainsapp';

function AppleIcon({ className = 'h-6 w-6 shrink-0' }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.69-2.4.59-3.65-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.57 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
    </svg>
  );
}

function PlayIcon({ className = 'h-6 w-6 shrink-0' }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
    </svg>
  );
}

function StoreButtons({ size = 'md', className = '' }) {
  const isLg = size === 'lg';
  const iconClass = isLg ? 'h-5 w-5 shrink-0 sm:h-6 sm:w-6' : 'h-5 w-5 shrink-0';
  const buttonPad = isLg
    ? 'gap-2 px-3 py-3 sm:gap-3 sm:px-6 sm:py-3.5'
    : 'gap-2 px-3 py-2.5 sm:gap-3 sm:px-5 sm:py-3';
  const labelClass = 'text-sm font-bold leading-tight text-white sm:text-base';
  const subClass =
    'hidden min-[380px]:block text-[11px] font-semibold uppercase leading-tight text-white/90 sm:text-xs';

  return (
    <div
      className={`mx-auto flex w-full max-w-lg flex-nowrap items-stretch justify-center gap-2 sm:max-w-xl sm:gap-3 ${className}`}
    >
      <a
        href={IOS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`btn-store-primary flex min-w-0 flex-1 basis-0 items-center justify-center ${buttonPad}`}
      >
        <AppleIcon className={iconClass} />
        <span className="min-w-0 text-left">
          <span className={subClass}>Download on the</span>
          <span className={`block ${labelClass}`}>App Store</span>
        </span>
      </a>
      <a
        href={ANDROID_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`btn-store-ghost flex min-w-0 flex-1 basis-0 items-center justify-center ${buttonPad}`}
      >
        <PlayIcon className={iconClass} />
        <span className="min-w-0 text-left">
          <span className={subClass}>Get it on</span>
          <span className={`block ${labelClass}`}>Google Play</span>
        </span>
      </a>
    </div>
  );
}

export default StoreButtons;
